import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';

const addressValidationStatusValues = {
  unverified: 0,
  verified: 1,
  warning: 2,
  error: 3,
};

const addressValidationStatusMapper = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  const value = addressValidationStatusValues[appliedFilter.criterionArgumentValue];
  return {
    normalizableCollectionFilters: [
      {
        column: 'ShipToVerificationStatus',
        values: [value],
        isIn: criteria.isIn,
        isNull: criteria.isNull,
      },
    ],
  };
};

export default addressValidationStatusMapper;
